// extracted by mini-css-extract-plugin
export default {"chipsInput":"chips-input_chipsInput__-n1NS","input":"chips-input_input__+jGOp","disabled":"chips-input_disabled__aO91T","menu":"chips-input_menu__npIZh"};